
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { UserModule } from '@/store/modules/user';
import { getBranchServicerList } from '@/api/branch';
import { addGroupCs, editGroupCs } from '@/api/group';

import DialogSetStaff from '../../staff/components/setStaff.vue';

@Component({
  name: 'branchCustomerGroupsDialog',
  components: {
    DialogSetStaff
  }
})
export default class extends Vue {
  @Prop({
    type: Boolean,
    default: false
  })
  dialogServicerVisible!: Boolean;
  // @Prop({
  //   type: Array,
  //   default: []
  // })
  // selectSevicer!: Array<Object>;
  @Prop({
    type: Object,
    default: () => {},
  })
  editorData!: any;

  private listQuery = {
    id: '',
    name: ''
  };
  private active = 0
  private listData = {
    more: false,
    list: []
  };
  private loading = false;
  private moreLoading = false;
  private servicerMore = false;
  private currentServicerListPage = 1;
  private selectedDynamicTags:any=[]

  // 选择人员
  private dialogSetStaffVisible = false
  private radioSelectedStaff = true
  private searchform:any= {
    servicer: '',
    user: ''
  }
  private groupId='';

  created() {
    if (!this.editorData.customer_list) {
      this.editorData.customer_list = []
    }
    if (!this.editorData.servicer_company_list) {
      this.editorData.servicer_company_list = []
    }
    if (this.editorData.id) {
      this.groupId = this.editorData.id
    } else {
      this.groupId = ''
    }
  }
  private loadMore() {
    this.currentServicerListPage = this.currentServicerListPage + 1;
    this.getBranchServicerList();
  }
  private getBranchServicerList() {
    let that = this;
    const params:any = {
      company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0',
      user_id: UserModule.getUserId,
      page: this.currentServicerListPage,
      size: 10
    };
    if (this.listQuery.id) {
      params.only_id = this.listQuery.id;
    }
    if (this.listQuery.name) {
      params.servicer_company_name = this.listQuery.name;
    }
    getBranchServicerList(params)
      .then(res => {
        if (res && res.data) {
          if (this.currentServicerListPage === 1) {
            this.listData.list = res.data.list;
          } else {
            this.listData.list = this.listData.list.concat(res.data.list);
          }
          if (res.data.page_count > this.currentServicerListPage) {
            this.servicerMore = true;
          } else {
            this.servicerMore = false;
          }
          // 设置选中
          this.$nextTick(function() {
            if (this.editorData.servicer_company_list && this.editorData.servicer_company_list.length > 0) {
              this.editorData.servicer_company_list.forEach((ser:any) => {
                let have = this.listData.list.filter((v:any) => {
                  return v.id === ser.id;
                });
                if (have && have.length > 0) {
                  this.selectedDynamicTags.push(have[0]);
                }
                that.toggleSelection([have[0]]);
              });
            } else {
              if (this.selectedDynamicTags && this.selectedDynamicTags.length > 0) {
                this.selectedDynamicTags.forEach((ser:any) => {
                  let have = this.listData.list.filter((v:any) => {
                    return v.id === ser.id;
                  });
                  if (have && have.length > 0) {
                    this.selectedDynamicTags.push(have[0]);
                  }
                  that.toggleSelection([have[0]]);
                });
              }
            }
          });
        } else {
          this.listData.list = [];
        }
        this.moreLoading = false;
      })
      .catch(err => {
        this.showErrorMsg(err.msg);
      });
  }
  private serch() {
    this.getBranchServicerList();
  }
  private resetData() {
    this.listQuery.id = '';
    this.listQuery.name = '';
    this.getBranchServicerList();
  }
  close() {
    this.$emit('close', false);
  }

  private handleSelectionChange(val: []) {
    this.selectedDynamicTags = val;
  }
  private closeTagHandle(val: any) {
    let _this = this;
    _this.selectedDynamicTags.splice(_this.selectedDynamicTags.indexOf(val), 1);
    for (let index = 0; index < _this.listData.list.length; index++) {
      if ((_this.listData.list[index] as any).id === (val as any).id) {
        _this.toggleSelection([_this.listData.list[index]]);
      }
    }
  }

  private toggleSelection(rows: any) {
    if (rows) {
      rows.forEach((row: any) => {
        if (this.$refs.tablelist) {
          (this.$refs.tablelist as any).toggleRowSelection(row);
        }
      });
    } else {
      (this.$refs.tablelist as any).clearSelection();
    }
  }
  private prevHandle() {
    if (this.active === 2) {
      this.active = 1;
    } else {
      this.active = 0
    }
  }
  private nextHandle() {
    if (this.active === 0) {
      (this.$refs.formName as any).validate((valid: any) => {
        if (valid) {
          this.active = 1;
          this.getBranchServicerList();
        } else {
          return false;
        }
      });
    } else if (this.active === 1) {
      if (this.selectedDynamicTags && this.selectedDynamicTags.length > 0) {
        // this.$emit('nextHandle', this.selectedDynamicTags);
        this.active = 2
        this.radioSelectedStaff = false;
        this.dialogSetStaffVisible = true;
      } else {
        this.showErrorMsg('请选择服务方');
      }
    }
  }

  private searchUser(val:any) {
    this.searchform.user = val;
  }
  private selectUser(val: any) {
    this.editorData.customer_list = val;
    if (this.groupId) {
      this.addAndEditGroups(this.editorData.group_name, 2);
    } else {
      this.addAndEditGroups(this.editorData.group_name, 1);
    }
  }
  private closeSetStaffHandle(val: any) {
    this.active = 1;
    this.getBranchServicerList();
    this.dialogSetStaffVisible = val;
  }

  private addAndEditGroups(name:string, type:number) {
    let servicerCompany:any = [];
    // this.groupServicer.forEach((element:any) => {
    this.selectedDynamicTags.forEach((element:any) => {
      let ser:any = {};
      ser.servicer_company_id = element.servicer_company_id;
      ser.servicer_company_name = element.servicer_company_name;
      servicerCompany.push(ser);
    });
    let userList:any = [];
    this.editorData.customer_list.forEach((user:any) => {
      let u:any = {};
      u.user_id = user.id;
      u.user_name = user.name;
      userList.push(u);
    });
    let params:any = {};
    params.company_id = UserModule.getCompanyId;
    params.user_id = UserModule.getUserId;
    params.group_type = 13;
    params.group_name = name;
    params.servicer_company = JSON.stringify(servicerCompany);
    params.customer_user = JSON.stringify(userList);
    switch (type) {
      case 1:
        addGroupCs(params).then(res => {
          this.showSecussMsg((res as any).msg);
          this.close();
          this.dialogSetStaffVisible = false;
          this.$emit('selectedGroup');
        }).catch(err => {
          this.showErrorMsg(err.msg);
        });
        break;
      case 2:
        params.group_id = this.groupId;
        editGroupCs(params).then(res => {
          this.showSecussMsg((res as any).msg);
          this.close();
          this.dialogSetStaffVisible = false;
          this.$emit('selectedGroup');
        }).catch(err => {
          this.showErrorMsg(err.msg);
        });
        break;
    }
  }

  private customHeight = window.innerHeight * 0.4;
  private showSecussMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: this.customHeight,
      customClass: 'notification-center',
      type: 'success'
    });
  }
  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }
}
